import { asis } from '@proc7ts/primitives';
import { URLSearchParams } from 'node:url';
import { RequestCapability } from '../../core/request-capability.js';
import { requestExtension } from '../../core/request-modification.js';
import { readAll } from '../../impl/read-all.js';
import { HttpError } from '../http-error.js';
/**
 * @internal
 */
const URL_ENCODED_MIMES = {
    'text/plain': 1,
    'application/x-www-form-urlencoded': 1,
};
/**
 * @internal
 */
class FormDecodingCapability extends RequestCapability {
    #transform;
    constructor(transform) {
        super();
        this.#transform = transform;
    }
    for(handler) {
        return async (context) => {
            const { request } = context;
            const { 'content-type': contentType = 'text/plain' } = request.headers;
            if (!URL_ENCODED_MIMES[contentType]) {
                return Promise.reject(new HttpError(415, { details: `application/x-www-form-urlencoded request expected` }));
            }
            const params = new URLSearchParams(await readAll(request));
            return context.next(handler, requestExtension({
                requestBody: await this.#transform(params, context),
            }));
        };
    }
    withBody(transformer) {
        return new FormDecodingCapability(transformer);
    }
}
/**
 * URL-encoded form decoding capability.
 *
 * Represents form data submitted as `application/x-www-form-urlencoded` as a {@link RequestBodyMeans.requestBody
 * request body} of type `URLSearchParams`.
 */
export const FormDecoding = new FormDecodingCapability(asis);
//# sourceMappingURL=form-decoding.capability.js.map